import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import humanTime from 'flarum/common/helpers/humanTime';
import getRarityInfo from '../../common/helpers/getRarityInfo';
export default class BadgeCard extends Component {
  view() {
    const badge = this.attrs.badge;
    const totalUsers = app.forum.attribute('userCount') || 1;
    const rarityInfo = getRarityInfo(badge.earnedCount(), totalUsers);
    const _this$attrs = this.attrs,
      earnedAt = _this$attrs.earnedAt,
      isFavorite = _this$attrs.isFavorite,
      isHidden = _this$attrs.isHidden,
      isNew = _this$attrs.isNew,
      isManual = _this$attrs.isManual,
      isOwner = _this$attrs.isOwner,
      isOwned = _this$attrs.isOwned,
      reason = _this$attrs.reason;

    // Collect all indicators to show (order: owned, new, favorite, hidden, manual)
    const indicators = [];

    // Owned indicator (for global badges page)
    if (isOwned && !isOwner) {
      indicators.push(m("span", {
        className: "BadgeCard-indicator BadgeCard-indicator--owned",
        title: app.translator.trans('fof-badges.forum.owned_badge')
      }, m("i", {
        className: "fas fa-check"
      })));
    }

    // New indicator
    if (isNew) {
      indicators.push(m("span", {
        className: "BadgeCard-indicator BadgeCard-indicator--new",
        title: app.translator.trans('fof-badges.forum.new_tag')
      }, m("i", {
        className: "fas fa-certificate"
      })));
    }

    // Owner indicators (favorite, hidden)
    if (isOwner && isFavorite) {
      indicators.push(m("span", {
        className: "BadgeCard-indicator BadgeCard-indicator--favorite",
        title: app.translator.trans('fof-badges.forum.user.favorite_badge')
      }, m("i", {
        className: "fas fa-star"
      })));
    }
    if (isOwner && isHidden) {
      indicators.push(m("span", {
        className: "BadgeCard-indicator BadgeCard-indicator--hidden",
        title: app.translator.trans('fof-badges.forum.user.hidden_badge')
      }, m("i", {
        className: "fas fa-eye-slash"
      })));
    }

    // Manual indicator
    if (isManual) {
      indicators.push(m("span", {
        className: "BadgeCard-indicator BadgeCard-indicator--manual",
        title: app.translator.trans('fof-badges.forum.user.manually_awarded')
      }, m("i", {
        className: "fas fa-hand-holding"
      })));
    }

    // Description: show reason if available, otherwise badge description
    const description = reason || badge.description();
    return m("div", {
      className: "BadgeCard",
      onclick: e => {
        var _this$attrs$onclick, _this$attrs2;
        e.preventDefault();
        (_this$attrs$onclick = (_this$attrs2 = this.attrs).onclick) == null || _this$attrs$onclick.call(_this$attrs2);
      },
      role: "button",
      tabindex: 0,
      onkeydown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          var _this$attrs$onclick2, _this$attrs3;
          e.preventDefault();
          (_this$attrs$onclick2 = (_this$attrs3 = this.attrs).onclick) == null || _this$attrs$onclick2.call(_this$attrs3);
        }
      }
    }, indicators.length > 0 && m("div", {
      className: "BadgeCard-indicators"
    }, indicators), m("div", {
      className: "BadgeCard-icon",
      style: {
        backgroundColor: badge.backgroundColor(),
        color: badge.iconColor()
      }
    }, m("i", {
      className: badge.icon()
    })), m("div", {
      className: "BadgeCard-content"
    }, m("div", {
      className: "BadgeCard-name"
    }, badge.name()), description && m("div", {
      className: "BadgeCard-description"
    }, description), m("div", {
      className: "BadgeCard-stats"
    }, m("span", {
      className: "BadgeCard-rarity BadgeCard-rarity--".concat(rarityInfo.tier),
      style: {
        color: rarityInfo.color
      }
    }, m("i", {
      className: "fas fa-gem"
    }), rarityInfo.label), earnedAt ? m("span", {
      className: "BadgeCard-earnedAt"
    }, m("i", {
      className: "fas fa-calendar-check"
    }), humanTime(earnedAt instanceof Date ? earnedAt : new Date(earnedAt))) : m("span", {
      className: "BadgeCard-earned"
    }, m("i", {
      className: "fas fa-users"
    }), app.translator.trans('fof-badges.forum.earned_by', {
      count: badge.earnedCount()
    })))));
  }
}
flarum.reg.add('fof-badges', 'forum/components/BadgeCard', BadgeCard);